import installer from './defaults'

export * from '@ll-plus/components'
export * from '@ll-plus/constant'
export * from '@ll-plus/hooks'
export * from '@ll-plus/locale'
export * from '@ll-plus/utils'

export const install = installer.install
export default installer
